export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 80 },
  { key: '3', headerName: 'Audit Type', field: 'auditType', hide: false, width: 120 },
  {
    key: '4', headerName: 'Audit Number', field: 'audit_id', hide: false, width: 160
  },
  { key: '5', headerName: 'Outlet Name', field: 'outlet_name', hide: false, width: 160 },
  { key: '7', headerName: 'Submission Date', field: 'created_at', hide: false, width: 160 },
  {
    key: '8', headerName: 'Actual Score', field: 'total_mark', hide: false, width: 130
  },
  { key: '9', headerName: 'Waiting at', field: 'waitingFor', hide: false, width: 200 },
  { key: '10', headerName: 'Aging Days', field: 'agingDays', hide: false, width: 120 },

];
